import {
  createResource,
  patchResource,
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const MODEL_PREFIX = 'admin'

const BUILDING_LIST_LINK = prefixAPI('/building/list/', MODEL_PREFIX)
const SHOP_LIST_LINK = prefixAPI('shop/list/', '')
const SHOP_PAGINATION_LIST_LINK = prefixAPI('shop/pagination-list/{page}', '')
const FLOOR_UPDATE_LINK = prefixAPI('/floor/{label}/update/', MODEL_PREFIX)
const FLOOR_RETRIEVE_LINK = prefixAPI('/floor/{label}/update/', MODEL_PREFIX)

export const buildingList = createResource(BUILDING_LIST_LINK)
export const floorUpdate = createResource(FLOOR_UPDATE_LINK, patchResource)
export const floorRetrieve = createResource(FLOOR_RETRIEVE_LINK)
export const shopList = createResource(SHOP_LIST_LINK)
export const shopPaginationList = createResource(SHOP_PAGINATION_LIST_LINK)
